/* eslint-disable prefer-const */
import store from '@/store'
import { isMiniProgram, isIOS } from '@/utils/index'
import router from '@/router'

/**
 * 跳转页面方法封装
 * @param routeUrl 路由页面路径
 */
export const mixinGoPage = (routeUrl) => {
  console.log('routeUrl', routeUrl)
  let absoluteUrl
  if (/^http/.test(routeUrl)) {
    absoluteUrl = routeUrl
  } else {
    absoluteUrl = location.href.replace(/#\/.+$/, `#${routeUrl}`)
  }
  console.log('absoluteUrl', absoluteUrl)
  if (hcApp.isHCApp()) {
    // 调用webview多开方法
    hcApp.postMessage({
      methodName: 'openNewWebview',
      params: { url: absoluteUrl },
    })
  } else if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        wx.miniProgram.navigateTo({ url: `/pages/webview/store?url=${encodeURIComponent(absoluteUrl)}` })
      } else {
        if (/^http/.test(routeUrl)) {
          location.href = routeUrl
        } else {
          router.push(routeUrl)
        }
      }
    })
  } else {
    if (/^http/.test(routeUrl)) {
      location.href = routeUrl
    } else {
      router.push(routeUrl)
    }
  }
}

/**
 * 页面返回方法封装
 * @param step 回退层级，-1代表回退上一层
 */
export const mixinGoBack = (step) => {
  if (hcApp.isHCApp()) {
    // 调用webview返回方法
    hcApp.postMessage({
      methodName: 'goBack',
    })
  } else if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
    wx.miniProgram.getEnv((res) => {
      console.log(res)
      if (res.miniprogram) {
        // bugfix: ios下必须要加延时才能返回
        if (isIOS()) {
          setTimeout(() => {
            wx.miniProgram.navigateBack({ delta: 1 })
          }, 1000)
        } else {
          wx.miniProgram.navigateBack({ delta: 1 })
        }
      } else {
        history.go(step || -1)
      }
    })
  } else {
    history.go(step || -1)
  }
}

/**
 * 确认登录
 * @returns {Promise}
 */
export const confirmLogin = async () => {
  const result = isMiniProgram()
  if (result) {
    return {}
  } else {
    const userInfo = await hcApp.postMessage({ methodName: 'confirmLogin' })
    if (userInfo.acpToken) {
      await store.dispatch('getUserInfo')
      return userInfo
    } else {
      throw new Error('用户未登录')
    }
  }
}

/**
 * 数字格式化，如果是小数则保留两位小数，不是小数则取整
 * @param number
 * @returns {number}
 */
export const formatNumberFix = (number) => {
  number = Number(number)
  if (isNaN(number)) {
    return 0
  }

  if (('' + number).indexOf('.') > -1) {
    return number.toFixed(2)
  } else {
    return number
  }
}

/**
 * 金钱单位置换  2999 --> 2,999.00
 * @param val
 * @param unit
 * @returns {*}
 */
export function unitPrice(price, toFix = false) {
  let _price
  const regExp = /\B(?=(\d{3})+(?!\d))/g
  try {
    _price = Number(price)
    if (Number.isNaN(_price)) {
      return 0
    }
    if (!Number.isInteger(_price)) {
      _price = _price.toFixed(2)
    }
    if (toFix) {
      return String(Number(_price).toFixed(2)).replace(regExp, ',')
    } else {
      return String(Number(_price)).replace(regExp, ',')
    }
  } catch (error) {
    console.log(error)
    return price || 0
  }
}

// 金融计算器

// 车辆总价：dpayment  首付比例：dpRatio  利率： interestRate 例：3.99% => 0.0399  贷款期限:mlength
export function financialCalculator(dpayment, dpRatio, interestRate, mlength) {
  let _dpayment = Number(dpayment)
  // console.log(_dpayment, '车辆总价')
  let _dpRatio = Number(dpRatio)
  // console.log(_dpRatio, '首付比例')
  let _interestRate = Number(interestRate) / 12
  // console.log(_interestRate, '利率')
  let _mlength = Number(mlength)
  // console.log(_mlength, '贷款期限')
  let dpaymentMy = _dpayment * _dpRatio // 首付金额
  // console.log(dpaymentMy, '首付金额')
  let finalPayment = _dpayment - dpaymentMy // 尾款
  // console.log(finalPayment, '尾款')

  let monthlyPayment =
    (Math.pow(1 + _interestRate, _mlength) * _interestRate * finalPayment) / (Math.pow(1 + _interestRate, _mlength) - 1) // 月供
  // console.log(monthlyPayment, '月供')

  let allInterest = monthlyPayment * _mlength - finalPayment
  return {
    dpaymentMy,
    finalPayment,
    monthlyPayment,
    allInterest,
  }
}

// 通过期数判断利率
export function interestRate(time) {
  if (time == 12) {
    return 5.3
  } else if (time == 24) {
    return 5.3
  } else if (time == 36) {
    return 5.3
  } else if (time == 48) {
    return 5.3
  } else if (time == 60) {
    return 5.3
  }
}

export function formatTimeFn(time) {
  if (!time) return ''
  const date = new Date(time)
  const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
  const minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  const second = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
  return `${date.getFullYear()}-${month}-${day} ${hour}:${minute}:${second}`
}

/**
 * 判断是否为小程序环境
 * @returns boolea
 */
export function isMiniProgramNew() {
  return navigator.userAgent.indexOf('miniProgram') > -1
}
